import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';

// Rendered when billing-action returned HTTP 409 state_conflict. Reads the
// pending intent from sessionStorage and offers a one-tap recovery.
export default function BillingModalStateConflictBanner({ pendingIntent, currentStatus, onRetry, onDismiss }) {
  if (!pendingIntent) return null;

  const copy = copyFor(pendingIntent.action, currentStatus);

  return (
    <View role="alert" aria-live="assertive" style={styles.root}>
      <Text style={styles.title}>{copy.title}</Text>
      <Text style={styles.body}>{copy.body}</Text>
      <View style={styles.row}>
        <Pressable onPress={onDismiss} style={({ pressed }) => [styles.btn, styles.secondary, pressed && { opacity: 0.7 }]}>
          <Text style={[styles.btnText, styles.secondaryText]}>Dismiss</Text>
        </Pressable>
        <Pressable onPress={onRetry} style={({ pressed }) => [styles.btn, styles.primary, pressed && { opacity: 0.8 }]}>
          <Text style={[styles.btnText, styles.primaryText]}>{copy.ctaLabel}</Text>
        </Pressable>
      </View>
    </View>
  );
}

function copyFor(action, currentStatus) {
  switch (action) {
    case 'cancel':
      return {
        title: 'Your subscription has already changed',
        body: `Your subscription is now ${currentStatus ?? 'in a different state'}. Review the latest details before retrying.`,
        ctaLabel: 'Review and retry',
      };
    case 'switch_plan':
      return {
        title: 'Plan change could not apply',
        body: 'Your subscription changed since you previewed the switch. Review the fresh preview before confirming.',
        ctaLabel: 'Review fresh preview',
      };
    case 'resume':
    case 'reactivate':
      return {
        title: 'Status changed',
        body: 'Your subscription is in a different state now. Please review before retrying.',
        ctaLabel: 'Review',
      };
    default:
      return {
        title: 'Something changed on our side',
        body: 'Please review the latest details.',
        ctaLabel: 'Review',
      };
  }
}

const styles = StyleSheet.create({
  root: { margin: 16, padding: 14, backgroundColor: 'rgba(255,123,0,0.08)', borderWidth: 1, borderColor: 'rgba(255,123,0,0.4)', borderRadius: 10 },
  title: { fontSize: 14, fontWeight: '600', color: '#FFB073' },
  body: { marginTop: 6, fontSize: 13, color: 'rgba(255,255,255,0.7)', lineHeight: 18 },
  row: { marginTop: 10, flexDirection: 'row', gap: 10 },
  btn: { flex: 1, paddingVertical: 10, borderRadius: 8, alignItems: 'center' },
  primary: { backgroundColor: '#0556F7' },
  secondary: { backgroundColor: 'transparent', borderWidth: 1, borderColor: 'rgba(255,255,255,0.2)' },
  btnText: { fontSize: 13, fontWeight: '600' },
  primaryText: { color: '#FFFFFF' },
  secondaryText: { color: '#FFFFFF' },
});
